import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const BellIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" viewBox="0 0 11 13" fill="none" className={className} onClick={onClick}>
      <path d="M5.33333 13C6.06667 13 6.66667 12.4 6.66667 11.6667H4C4 12.4 4.6 13 5.33333 13ZM9.33333 9V5.66667C9.33333 3.62 8.24667 1.90667 6.33333 1.45333V0H4.33333V1.45333C2.42667 1.90667 1.33333 3.61333 1.33333 5.66667V9L0 10.3333V11H10.6667V10.3333L9.33333 9ZM8 9.66667H2.66667V5.66667C2.66667 4.01333 3.67333 2.66667 5.33333 2.66667C6.99333 2.66667 8 4.01333 8 5.66667V9.66667Z" fill="currentColor"/>
    </svg>
  );
};

export default BellIcon;